export const BANNER_NOTIFICATION_MAINTENANCE = "maintenance";
export const BANNER_NOTIFICATION_EMERGENCY = "emergency";

export interface Banner {
  bannerId: number;
  brandId: number;
  startDate: string;
  endDate: string;
  text: string;
  updatedDate: string;
  notificationType: string;
}
